import { trackInteraction } from 'client/javascript/analytics';
import { getLocale } from 'client/javascript/util/locale';
import getClosestMarket from 'client/javascript/get_closest_market';
import {
  CHECK_AVAILABILITY_ID,
  CLOSE_WIZARD_BTN_ID,
  DESIRED_CAPACITY_INPUT_ID,
  DESIRED_CAPACITY_INCREASE_ID,
  DESIRED_CAPACITY_DECREASE_ID,
  LOCATION_DROPDOWN_ID,
  OPEN_WIZARD_BTN_ID,
  WIZARD_STEP_2_LINK_ID,
  getLocationDropdownSelectedId,
  getLocationDropdownSelectedName,
  getDesiredCapacityValue
} from './utils';

const locale = getLocale();

export async function setupWizardTrackingEvents(showWizardStep2) {
  //  Location Change Tracking Event
  const locationDropdown = document.getElementById(LOCATION_DROPDOWN_ID);
  locationDropdown.addEventListener('click', () => {
    trackInteraction({
      label: 'segmentor form interaction market'
    });
  });

  //  Open Wizard Tracking Event
  const openWizardBtn = document.getElementById(OPEN_WIZARD_BTN_ID);
  openWizardBtn.addEventListener('click', async () => {
    const closestLocation = (await getClosestMarket()) || {};
    const selectedLocationId = getLocationDropdownSelectedId();
    const selectedLocationName = getLocationDropdownSelectedName();

    trackInteraction({
      label: 'open segmentation overlay',
      marketName: selectedLocationName,
      marketID: selectedLocationId,
      isGeolocatedMarket: closestLocation.name === selectedLocationName
    });
  });

  // Close Wizard Tracking Event
  const closeWizardBtn = document.getElementById(CLOSE_WIZARD_BTN_ID);
  closeWizardBtn.addEventListener('click', () => {
    trackInteraction({
      label: 'close segmentation overlay'
    });
  });

  // Desired Capacity Change Tracking Event
  const handleCompanySizeInteraction = () => {
    trackInteraction({
      label: 'segmentor form interaction company size'
    });
  };
  const desiredCapacityInput = document.getElementById(DESIRED_CAPACITY_INPUT_ID);
  const desiredCapacityIncrease = document.getElementById(DESIRED_CAPACITY_INCREASE_ID);
  const desiredCapacityDecrease = document.getElementById(DESIRED_CAPACITY_DECREASE_ID);

  desiredCapacityInput.addEventListener('input', handleCompanySizeInteraction);
  desiredCapacityIncrease.addEventListener('click', handleCompanySizeInteraction);
  desiredCapacityDecrease.addEventListener('click', handleCompanySizeInteraction);

  // Wizard Form Submitted (step 1)
  const checkAvailabilityBtn = document.getElementById(CHECK_AVAILABILITY_ID);
  checkAvailabilityBtn.addEventListener('click', async () => {
    const closestLocation = (await getClosestMarket()) || {};
    const desiredCapacity = getDesiredCapacityValue();
    const selectedLocationId = getLocationDropdownSelectedId();
    const selectedLocationName = getLocationDropdownSelectedName();

    trackInteraction({
      label: 'segmentor form submitted',
      locale,
      marketName: selectedLocationName,
      marketID: selectedLocationId,
      companySize: desiredCapacity,
      isGeolocatedMarket: closestLocation.name === selectedLocationName
    });
  });

  // Workspace link (step 1)
  const wizardStep2Link = document.getElementById(WIZARD_STEP_2_LINK_ID);
  wizardStep2Link.addEventListener('click', () => {
    trackInteraction({
      label: showWizardStep2 ? 'clicks on link to step 2 on insterstitial' : 'clicks on link on interstitial'
    });
  });
}

export default setupWizardTrackingEvents;
